/*global Highlight*/
/*eslint no-undef: "error"*/

// The CSS Custom Highlight API is recent enough that browsers still in the wild
// lack it. Degrade to no highlighting rather than throwing: callers run this from
// effects, where a TypeError would take the surrounding screen down with it.
function highlightsSupported() {
    return typeof CSS !== 'undefined' && CSS.highlights !== undefined
}

export function registerHighlight (name, ranges) {
    if (!highlightsSupported()) return

    const highlight = new Highlight()
    for (let i = 0; i < ranges.length; i++) {
        highlight.add(ranges[i]);
    }

    CSS.highlights.set(name, highlight);
}

export function clearHighlights() {
    if (!highlightsSupported()) return

    CSS.highlights.clear();
}
